'use strict';

/**
 * Employees Block functionality
 * Handles department filtering with client-side filtering
 */

const employeesBlock = document.querySelector('.uecc-employees');

if (employeesBlock) {
	const grid = document.getElementById('employees-grid');
	const filtersContainer = employeesBlock.querySelector('.employees__filters .filters-container');
	const MOBILE_BREAKPOINT = 768;
	
	/**
	 * Check if viewport is mobile size
	 */
	function isMobile() {
		return window.innerWidth <= MOBILE_BREAKPOINT;
	}
	
	if (filtersContainer) {
		const filterBtns = filtersContainer.querySelectorAll('.btn');
		let activeBtn = filtersContainer.querySelector('.btn.active');
		let currentDepartment = activeBtn ? activeBtn.dataset.department : 'all';
		
		// Create and append the sliding indicator (only visible on desktop via CSS)
		const indicator = document.createElement('span');
		indicator.className = 'filter-indicator';
		filtersContainer.prepend(indicator);
		
		/**
		 * Position the indicator on a button
		 * @param {HTMLElement} btn - The button to position on
		 * @param {number} offset - Optional horizontal offset for hover effect
		 */
		function positionIndicator(btn, offset = 0) {
			if (!btn || isMobile()) return;
			
			const containerRect = filtersContainer.getBoundingClientRect();
			const btnRect = btn.getBoundingClientRect();
			
			const left = btnRect.left - containerRect.left + offset;
			const width = btnRect.width;
			
			indicator.style.width = `${width}px`;
			indicator.style.transform = `translateX(${left}px)`;
		}
		
		// Initialize indicator position
		positionIndicator(activeBtn);
		
		// Recalculate on window resize
		window.addEventListener('resize', () => {
			positionIndicator(activeBtn);
		});
		
		/**
		 * Filter employees by department
		 * @param {string} department - The department slug to filter by
		 */
		function filterEmployees(department) {
			const employees = grid.querySelectorAll('.employee-card');
			
			employees.forEach((employee, index) => {
				const employeeDepartments = employee.dataset.department || '';
				const departments = employeeDepartments.split(' ');
				
				// Check if employee belongs to selected department
				const shouldShow = department === 'all' || departments.includes(department);
				
				if (shouldShow) {
					employee.classList.remove('is-hidden');
					employee.classList.add('is-visible');
					// Stagger animation
					employee.style.animationDelay = `${index * 0.05}s`;
				} else {
					employee.classList.add('is-hidden');
					employee.classList.remove('is-visible');
				}
			});
		}
		
		/**
		 * Handle department filter click
		 */
		filterBtns.forEach(btn => {
			btn.addEventListener('click', function() {
				const department = this.dataset.department;
				
				if (department === currentDepartment) return;
				
				// Update active state
				filterBtns.forEach(b => b.classList.remove('active'));
				this.classList.add('active');
				activeBtn = this;
				
				// Move indicator to new position (only on desktop)
				if (!isMobile()) {
					positionIndicator(this);
				}
				
				// Filter employees
				currentDepartment = department;
				filterEmployees(department);
			});
			
			// Hover effect - slight movement towards hovered button (desktop only)
			btn.addEventListener('mouseenter', function() {
				if (isMobile() || this.classList.contains('active')) return;
				
				const activeBtnRect = activeBtn.getBoundingClientRect();
				const hoveredBtnRect = this.getBoundingClientRect();
				
				// Calculate direction and apply subtle offset
				const activeCenter = activeBtnRect.left + activeBtnRect.width / 2;
				const hoveredCenter = hoveredBtnRect.left + hoveredBtnRect.width / 2;
				const direction = hoveredCenter > activeCenter ? 1 : -1;
				const offset = direction * 8; // 8px nudge
				
				positionIndicator(activeBtn, offset);
			});
			
			btn.addEventListener('mouseleave', function() {
				if (isMobile()) return;
				// Reset to active button position
				positionIndicator(activeBtn);
			});
		});
	}
}
